const TallyConnectionGuide = () => {
    return (
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">
                    <i className="ti ti-plug-connected me-2" />
                    Tally Connection Guide
                </h5>
            </div>

            <div className="card-body">

                {/* Step 1 */}
                <div className="mb-4">
                    <h4 className="fw-semibold">
                        <span className="badge bg-primary me-2">Step 1</span>
                        <span className="text-primary">Install & Open Tally</span>
                    </h4>
                    <ul className="mb-0" style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Install <strong>Tally Prime</strong> (Latest Version recommended)</li>
                        <li>Open your <strong>Company</strong> inside Tally</li>
                    </ul>
                </div>

                {/* Step 2 */}
                <div className="mb-4">
                    <h4 className="fw-semibold">
                        <span className="badge bg-primary me-2">Step 2</span>
                        <span className="text-primary">Enable XML / HTTP Access</span>
                    </h4>
                    <ul style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Press <strong>F1 → Help</strong></li>
                        <li>Go to <strong>Tally Prime → Edit</strong></li>
                        <li>Enable <strong>Use Tally as Web Service = Yes</strong></li>
                        <li>Set <strong>Port = 9000</strong> (default)</li>
                    </ul>
                </div>

                {/* Step 3 */}
                <div className="mb-4">
                    <h4 className="fw-semibold">
                        <span className="badge bg-primary me-2">Step 3</span>
                        <span className="text-primary">Allow Company for Sync</span>
                    </h4>
                    <ul style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Open the company you want to sync</li>
                        <li>Ensure <strong>Company is NOT in Educational Mode</strong></li>
                        <li>Keep Tally running during sync</li>
                    </ul>
                </div>

                {/* Step 4 */}
                <div className="mb-4">
                    <h4 className="fw-semibold">
                        <span className="badge bg-primary me-2">Step 4</span>
                       <span className="text-primary"> Sync from Application</span>
                    </h4>
                    <ul style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Go to <strong>Dashboard → Sync with Tally</strong></li>
                        <li>Click <strong>Sync with Tally</strong></li>
                        <li>Wait until sync completes</li>
                        <li>Success message will appear on top-right</li>
                    </ul>
                </div>

                {/* Step 5 */}
                <div className="mb-4">
                    <h4 className="fw-semibold">
                        <span className="badge bg-primary me-2">Step 5</span>
                        <span className="text-primary">Download XML (Optional)</span>
                    </h4>
                    <ul style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Click <strong>Download XML</strong> dropdown</li>
                        <li>Select required data (Ledgers, Vouchers, Payments)</li>
                        <li>Import XML manually into Tally if required</li>
                    </ul>
                </div>

                {/* Important Notes */}
                <div className="alert alert-warning" style={{
                    backgroundColor: "#ffe20a",
                    borderRadius: "10px"
                }}>
                    <h4 className="fw-semibold mb-2">
                        <i className="ti ti-alert-triangle me-1" />
                        <span className="text-primary">Important Notes</span>
                    </h4>
                    <ul className="mb-0" style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>Tally must be running during sync</li>
                        <li>Port <strong>9000</strong> must not be blocked by firewall</li>
                        <li>Only one Tally instance should run at a time</li>
                        <li>Company name must match while importing XML</li>
                    </ul>
                </div>

                {/* Troubleshooting */}
                <div className="alert alert-info" style={{
                    backgroundColor: "rgb(0 231 55)",
                    borderRadius: "10px"
                }}>
                    <h4 className="fw-semibold mb-2">
                        <i className="ti ti-help-circle me-1" />
                        <span className="text-primary">Troubleshooting</span>
                    </h4>
                    <ul className="mb-0" style={{
                        padding: "20px",
                        background: "#eee",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <li>If sync fails, restart Tally</li>
                        <li>Check if port <strong>9000</strong> is accessible</li>
                        <li>Ensure no antivirus blocks Tally</li>
                        <li>Try downloading XML manually</li>
                    </ul>
                </div>

            </div>
        </div>
    );
};

export default TallyConnectionGuide;
